import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79a7c947"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-update" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-header-center" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "绑定手机号")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "手机号仅用于登录和保护帐号", -1))
const _hoisted_4 = { class: "account-update-input" }
const _hoisted_5 = { class: "account-update-input" }
const _hoisted_6 = { class: "account-update-error" }
const _hoisted_7 = { class: "account-update-btns" }
const _hoisted_8 = ["disabled"]

import { reactive, ref, onMounted } from 'vue'
import { auth, getErrorMessage } from '@remote/utils/sso'
import { toast } from '@remote/utils/dialog'
import { checkNetworkState } from '@remote/store/utils'
import { usePromisifyDialog } from '@shared/utils/dialog'

type IData = {
  step: 'authentication' | 'updatePhone' | 'updatePassword'
  verificationCode: string
  phoneNumber: string
  countdown: number
  errorMessage: string
  isSubmit:boolean
}


export default /*#__PURE__*/_defineComponent({
  emits: ["dialog-close"],
  setup(__props, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {



const { close } = usePromisifyDialog(emit)

const isMountedRef = ref(false)

const handleClose = () => {
  isMountedRef.value = false
  setTimeout(() => {
    close(null)
  }, 300)
}

onMounted(async () => {
  setTimeout(() => {
    isMountedRef.value = true
  }, 0)
})

const data = reactive<IData>({
  step: 'authentication',
  verificationCode: '',
  phoneNumber: '',
  countdown: 0,
  errorMessage: '',
  isSubmit: false,
})


let getVerificationRet

const handleOnGetVerification = async () => {
  try {
    const params =  {
      phone_number: '+86 ' + data.phoneNumber,
      target: 'ANY',
      usage: 'PHONE_NUMBER_VERIFICATION',
      locale: 'zh',
    }

    getVerificationRet = await auth.getVerification(params)

    data.countdown = 60
    const timer = setInterval(() => {
      if (data.countdown > 0) {
        data.countdown = data.countdown - 1
      } else {
        clearInterval(timer)
        data.countdown = 0
      }
    }, 1000)
  } catch (error) {
    const errorMessage = getErrorMessage(error)
    data.errorMessage = errorMessage
    toast({ type: 'error', message: errorMessage })
  }
}

const handleOnBindNewPhone = async () => {
  const validate = () => {
    if (!getVerificationRet) {
      toast('请先获取验证码')
      data.errorMessage = '请先获取验证码'
      return false
    }
    if (!data.verificationCode) {
      toast('验证码不能为空')
      data.errorMessage = '验证码不能为空'
      return false
    }
    if (checkNetworkState()) {
      return false
    }
    return true
  }
  data.isSubmit = true
  try {
    if (!validate()) return data.isSubmit = false
    // 验证新手机短信验证码
    const verifyRet = await auth.verify({
      verification_code: data.verificationCode,
      verification_id: getVerificationRet?.verification_id,
    })

    // 获取sudo token
    const sudoTokenResponse = await auth.grantSudoToken({
      verification_token: verifyRet?.verification_token || '',
    })

    // 绑定手机
    await auth.bindPhone({
      phone_number: '+86 ' + data.phoneNumber,
      verification_token: verifyRet?.verification_token as string,
      sudo_token: sudoTokenResponse?.sudo_token,
    })
    handleClose()
    toast({ type: 'success', message: '手机号绑定成功' })
  } catch (error) {
    console.log(error)
    const errorMessage = getErrorMessage(error) || '手机号绑定失败'
    data.errorMessage = errorMessage
    toast({ type: 'error', message:  errorMessage})
  }
  data.isSubmit = false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["pop-wrapper", { 'is-mounted': isMountedRef.value }])
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              placeholder: "请输入手机号",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).phoneNumber) = $event))
            }, null, 512), [
              [_vModelText, _unref(data).phoneNumber]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              placeholder: "请输入验证码",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).verificationCode) = $event))
            }, null, 512), [
              [_vModelText, _unref(data).verificationCode]
            ]),
            _createElementVNode("span", {
              onClick: handleOnGetVerification,
              class: _normalizeClass({ 'is-loading': _unref(data).countdown > 0 && !!_unref(data).phoneNumber })
            }, _toDisplayString(_unref(data).countdown > 0 ? `(${_unref(data).countdown}s)` : '获取验证码'), 3)
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(data).errorMessage), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", {
              onClick: handleOnBindNewPhone,
              disabled: !_unref(data).verificationCode || !_unref(data).phoneNumber,
              class: _normalizeClass({'is-btn-loading': _unref(data).isSubmit})
            }, "完成", 10, _hoisted_8)
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})